import React from 'react';
import { Card } from '../ui/Card';
import { formatSeconds } from '../../utils/format';
import { healthBar, speedHealth } from '../../utils/health';
interface Row {
  id: string;
  label: string;
  seconds: number;
}
interface SpeedToLeadChartProps {
  title: string;
  description?: string;
  rows: Row[];
  onSelect?: (id: string) => void;
}
export function SpeedToLeadChart({
  title,
  description,
  rows,
  onSelect
}: SpeedToLeadChartProps) {
  const sorted = [...rows].sort((a, b) => a.seconds - b.seconds);
  const max = Math.max(...sorted.map(r => r.seconds), 1);
  return <Card className="px-6 py-5" data-id="element-380" data-mp="2g8iqu4frlpik">
      <h2 className="text-sm font-semibold text-ink-900" data-id="element-381" data-mp="2g9alnd1jfj7s">{title}</h2>
      {description ? <p className="mt-0.5 text-xs text-ink-500" data-id="element-382" data-mp="2l72ec9a0b9d1">{description}</p> : null}
      <ul className="mt-5 space-y-3.5" data-id="element-383" data-mp="2l597otze8p51">
        {sorted.map(row => {
        const pct = row.seconds / max * 100;
        const content = <>
              <div className="mb-1.5 flex items-center justify-between text-xs font-medium" data-id="element-384" data-mp="3dphf5bqjwgsw">
                <span className="text-ink-700" data-id="element-385" data-mp="2jh1u70sgn1ed">{row.label}</span>
                <span className="tabular text-ink-900" data-id="element-386" data-mp="2ehyxq4qjq3i0">{formatSeconds(row.seconds)}</span>
              </div>
              <div className="h-2 w-full overflow-hidden rounded-full bg-ink-100" data-id="element-387" data-mp="2s93pkkno9rhs">
                <div className={`h-full rounded-full transition-all duration-500 ${healthBar[speedHealth(row.seconds)]}`} style={{
              width: `${pct}%`
            }} data-id="element-388" data-mp="2nhlqy394g2zz" />
              </div>
            </>;
        return <li key={row.id} data-id="element-389" data-mp="2xaazoqdaf2rm">
              {onSelect ? <button type="button" onClick={() => onSelect(row.id)} className="w-full rounded-lg px-1 py-1 text-left transition-colors hover:bg-ink-50" data-id="element-390" data-mp="3b6erkd0ouz0x">
                  {content}
                </button> : <div className="px-1 py-1" data-id="element-391" data-mp="1ctepqd2ywpc1">{content}</div>}
            </li>;
      })}
      </ul>
    </Card>;
}